import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import ScrollHandler from '../ScrollHandler/ScrollHandler';

class Waypoint extends PureComponent {
    static propTypes = {
        /** String or Number to pass as a parameter to onEnter and onLeave */
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /** Function to call when the component is in View. */
        onEnter: PropTypes.func,
        /** Function to call when the component is no longer in View. */
        onLeave: PropTypes.func
    }

    static defaultProps = {
        label: '',
        onEnter: () => {},
        onLeave: () => {}
    }

    constructor(props) {
        super(props);
        /* Don't use state so child won't re-render every time we update the visible state */
        this.isVisible = false;
    }

    handleLazyLoad = (inView) => {
        const {label, onEnter, onLeave} = this.props;

        if (inView && !this.isVisible) {
            this.isVisible = true;
            onEnter(label);
        } else if (!inView && this.isVisible) {
            this.isVisible = false;
            onLeave(label);
        }
    }

    render() {
        const {children} = this.props;
        return (
            <ScrollHandler onLazyLoad={this.handleLazyLoad}>
                {children}
            </ScrollHandler>
        );
    }
}

export default Waypoint;
